import {FrontWebPodcastEpisodeModel} from "../../../generated";
import ListCss from "../List.module.scss";
import { EpisodeRow } from "../../Item/Podcast/EpisodeRow";

export const EpisodeRowList = (props: {
    items: FrontWebPodcastEpisodeModel[],
    twoItemsPerRow?: boolean,
    className?: string,
    smallVersion?: boolean
}) => {
    return <ul className={`d-flex align-justify-start flex-wrap ${ListCss.UlRow} ${props.className ?? ""}`}>
        {props.items.map((item, k) => (
            <li key={k} className={`flex-fill ${props.twoItemsPerRow ? ListCss.TwoItem: ""} ${props.smallVersion ? "" : ListCss.liPodcast} ${ k % 2 ? ListCss.Mud : ""}`}>
                <EpisodeRow episode={item} smallVersion={props.smallVersion} className={props.smallVersion ? "mb-4" : ""}/>
            </li>)
        )}</ul>
}
